import router from '@/router'
import { getItem } from '@/api/defaultApi'
import { vuexFileBase } from '@/store/compositionV2/utils/file'
import { LOGISTIC_DRIVER_URL, LogisticDriverApi } from '@/api/Logistic'
import { showAlertError } from '@/utils/store/alert'

const EDriverFiles = {
  passports: 'passports',
  drivers_license: 'drivers_license'
}

const initialState = () => {
  return {
    api: LogisticDriverApi,

    ...vuexFileBase.createState(Object.values(EDriverFiles)),

    urlApi: LOGISTIC_DRIVER_URL,
    id: null,
    driver: {
      full_name: '',
      phone: '',
      comment: '',
      default_car: null,
      drivers_license: [],
      passports: [],
      transport: []
    },
    validation: {
      full_name: {
        type: null,
        message: ''
      },
      phone: {
        type: null,
        message: ''
      }
    },
    isLoading: false,
    params: {
      expand: 'transport,passports,drivers_license,waybills,default_car'
    },
    paramsList: {
      'per-page': 1000,
      page: 1
    }
  }
}

const state = initialState

const mutations = {
  ...vuexFileBase.createMutations(),

  SET_DRIVER_UPDATE_INITIAL_STATE: (state) => {
    Object.assign(state, initialState())
  },

  SET_DRIVER_UPDATE: (state, driver) => {
    state.driver = {
      ...driver,
      default_car: driver.default_car ? {
        id: driver.default_car.id,
        name: `${driver.default_car.name} ${driver.default_car.number}`
      } : null,
      deletedPassports: [],
      deletedDriversLicense: [],
      transport: driver.transport ? driver.transport.map(transport => {
        return {
          id: transport.id,
          name: `${transport.name} ${transport.number}`
        }
      }) : [],
      passports: driver.passports ? driver.passports.map(e => {
        return {
          name: e.file_name,
          size: e.file_size,
          url: e.url,
          type: e.content_type,
          id: e.id
        }
      }) : [],
      drivers_license: driver.drivers_license ? driver.drivers_license.map(e => {
        return {
          name: e.file_name,
          size: e.file_size,
          url: e.url,
          type: e.content_type,
          id: e.id
        }
      }) : []
    }
    state.id = driver.id
  },

  SET_DRIVER_UPDATE_FULL_NAME: (state, value) => {
    state.driver.full_name = value
  },
  SET_DRIVER_UPDATE_PHONE: (state, value) => {
    state.driver.phone = value
  },
  SET_DRIVER_UPDATE_COMMENT: (state, value) => {
    state.driver.comment = value
  },

  SET_DRIVER_UPDATE_PASSPORTS: (state, value) => {
    state.driver.passports = value
  },

  SET_DRIVER_UPDATE_DEFAULT_CAR: (state, value) => {
    state.driver.default_car = value
  },

  SET_DRIVER_UPDATE_DRIVERS_LICENSE: (state, value) => {
    state.driver.drivers_license = value
  },

  SET_DRIVER_UPDATE_VALIDATION: (state, valid) => {
    if (valid.full_name) {
      state.validation.full_name.message = valid.full_name[0]
      state.validation.full_name.type = 'error'
    }
    if (valid.phone) {
      state.validation.phone.message = valid.phone[0]
      state.validation.phone.type = 'error'
    }
  },
  CLEAR_DRIVER_UPDATE_VALIDATION: (state, inputName) => {
    switch (inputName) {
      case 'full_name':
        state.validation.full_name = {
          type: null,
          message: ''
        }
        break
      case 'phone':
        state.validation.phone = {
          type: null,
          message: ''
        }
        break
      default:
        break
    }
  }
}

const actions = {
  ...vuexFileBase.createActions(),

  getDriverUpdate ({ commit, state }, id) {
    state.isLoading = true

    getItem(state.urlApi, id, state.params)
      .then(response => {
        commit('SET_DRIVER_UPDATE', response.data.data)
      })
      .catch(error => {
        console.log('ошибка получения водителя', error)
        console.log('ошибка получения водителя', error.response)
      })
      .finally(() => {
        state.isLoading = false
      })
  },

  async saveDriverUpdate ({ commit, state, dispatch }) {
    const data = {
      full_name: state.driver.full_name,
      phone: state.driver.phone,
      comment: state.driver.comment,
      transport: state.driver.transport.map(item => item.id),
      default_car_id: state.driver?.default_car?.id
    }

    try {
      if (!state.id) {
        await dispatch('createDriver', data)
      } else {
        await dispatch('updateDriver', { id: state.id, data })
      }

      await router.push({ name: 'LogisticDriverList' })
    } catch (e) {
      showAlertError(e)
      commit('SET_DRIVER_UPDATE_VALIDATION', e.response.data.validation)
    }
  },

  async createDriver ({ state, dispatch }, data) {
    const response = await LogisticDriverApi.create(data)
    const id = response.data.data.id
    await dispatch('checkAndPostNewFiles', {
      id,
      data: state.driver,
      addExpand: false
    })
  },

  async updateDriver ({ state, dispatch }, { id, data }) {
    await LogisticDriverApi.update(id, data)
    await dispatch('checkAndDeleteFiles', id)
    await dispatch('processPostAndSortFiles', { id, data: state.driver })
  },

  addDriverLicenseFileToDelete ({ commit }, { id }) {
    commit('ADD_FILE_TO_DELETE', { id, key: EDriverFiles.drivers_license })
  },
  addPassportFileToDelete ({ commit }, { id }) {
    commit('ADD_FILE_TO_DELETE', { id, key: EDriverFiles.passports })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
